import React from "react";
import { Card, Col, ListGroupItem, ListGroup, Row } from "react-bootstrap";
import style from "./HomeProjectCard.module.css";

const HomeProjectCard = ({ project }) => {
  console.log(project);
  const { name, image, technology, live, code } = project;
//   console.log(technology);
  return (
    <Col xs={12} sm={12} md={6} lg={4}>
      <Card style={{ width: "24rem" }}>
        <div className={style.card__img} style={{backgroundImage:`url(${image})`}}>
          
        </div>
        <div className={style.projectCard__container}>
          <Card.Body>
            <Card.Title>
              <h2 className={style.card__title}>{name}</h2>
            </Card.Title>
            <div className={style.project__technology} >
              {
                technology.map(tech =><span className={style.technology} key={tech}>{tech}</span>)
              }
            </div>
          </Card.Body>
          <Card.Body>
          {/* <button className={style.resume}>SEE DETAILS</button>
          <button className={style.resume}>LIVE DEMO</button> */}
          <a className={style.resume} href={live} target='_black'>Live Site</a>
          <a className={style.resume} href={code} target='_black'>Code Link</a>
          </Card.Body>
        </div>
      </Card>
    </Col>
  );
};

export default HomeProjectCard;
